import { FC, ReactElement } from 'react';
import { Icons } from 'src/assets/fonts/Icons/icons';
import { formatImagePath } from 'src/utils/formatter';
import Icon from 'src/view/components/Controls/Icon/Icon';
import Image from 'src/view/components/Image/Image';
import { history } from '~/services/history';
import './style.scss';

export interface IIntegrationItem {
  path: string;
  title: string;
  description?: string;
  icon?: Icons;
  image?: string;
  iconColor?: string;
  iconBackgroundColor?: string;
  isHidden?: boolean;
  imageClassName?: string;
}

const IntegrationItem: FC<IIntegrationItem> = (props: IIntegrationItem): ReactElement => {
  const onClick = () => {
    history.push(props.path);
  };

  return (
    <div className={`integration_item__wrapper ${props.isHidden ? 'hidden' : ''}`} onClick={onClick}>
      <div className="integration_item">
        <div
          className={`integration_item__image-wrapper ${props.iconBackgroundColor ? '' : 'bordered'}`}
          style={props.iconBackgroundColor ? { backgroundColor: props.iconBackgroundColor } : undefined}
        >
          {props.icon && <Icon name={props.icon} size={44} color={props.iconColor} />}
          {props.image && (
            <Image aspectRatio={1} src={formatImagePath(props.image)} wrapperClassName={`integration_item__image ${props.imageClassName || ''}`} />
          )}
        </div>

        <div className="integration_item__text-block">
          <p className="integration_item__title">{props.title}</p>
          {props.description && <p className="integration_item__description letter-spacing-5">{props.description}</p>}
        </div>
      </div>
    </div>
  );
};

export default IntegrationItem;
